module.exports = __webpack_public_path__ + "static/bg-iridium-6b13ffa2952de5c3a3e8cb825452a013.webp";